import {I18NUsfProvider, useIntl} from '@/modules/I18N';
import {SEO, SEOManager} from '@/modules/SEO';
import {ALIGN, Aurora, Box, COLOR, Header, InputField, InputValue, Layout, SPACE, Text} from '@lookiero/aurora';
import React, {useState, useMemo} from 'react';
import {MaskBottom} from '@/components/primitives/Masks/MaskBottom';
import {MaskTop} from '@/components/primitives/Masks/MaskTop';
import {TEXT, TEXT_COUNTRY} from './HomeSiteCom.definition';
import {styles} from './HomeSiteCom.styles';
import {Logo} from '@/components/primitives/Logo';
import {Country} from '@/types/Country';
import {FeatureFlagsProvider} from '@/modules/FeatureFlags';
import {getSiteByCountry} from '@/modules/Site/services';

const removeDomainFromHostname = (hostname: string): string => {
  return hostname.replace(/\.(com)$/i, '');
};

const getCountryURL = (country: Country) => {
  const {protocol, hostname, port, pathname, search, hash} = window.location;
  const urlHostname = `${removeDomainFromHostname(hostname)}.${getSiteByCountry(country)?.domain}`;
  const urlPort = port ? `:${port}` : '';
  return `${protocol}//${urlHostname}${urlPort}${pathname}${search}${hash}`;
};

export const HomeSiteCom: React.FC = () => (
  <I18NUsfProvider>
    <FeatureFlagsProvider>
      <HomeSiteComInner />
    </FeatureFlagsProvider>
  </I18NUsfProvider>
);
export const HomeSiteComInner: React.FC = () => {
  const {formatMessage} = useIntl();
  const [currentValue, setCurrentValue] = useState('');

  const countryList = useMemo(() => {
    return Object.keys(TEXT_COUNTRY).map(key => {
      return {name: formatMessage(TEXT_COUNTRY[key as Country]), value: key};
    });
  }, [formatMessage]);

  const selectText = formatMessage(TEXT.SELECT_TEXT);

  const redirectToLocationHref = (inputValue: InputValue): void => {
    if (inputValue) {
      const value = inputValue as Country;
      setCurrentValue(value);
      window.location.href = getCountryURL(value);
    }
  };

  return (
    <>
      <SEOManager />
      <SEO>
        <link rel="canonical" href="https://lookiero.com" />
        <link rel="alternate" hrefLang="x-default" href="https://lookiero.com" />
      </SEO>
      <Aurora>
        <Header style={styles.header} logo={<Logo />} />
        <Layout fullWidth style={styles.layout}>
          <Box alignItems={ALIGN.CENTER} style={styles.container}>
            <Box alignItems={ALIGN.END}>
              <MaskTop />
            </Box>
            <Box
              justifyContent={ALIGN.CENTER}
              paddingHorizontal={SPACE.SPACE_6}
              paddingVertical={SPACE.SPACE_8}
              style={styles.content}
            >
              <Text heading level={2}>
                {formatMessage(TEXT.TITLE)}
              </Text>
              <Text color={COLOR.TEXT_MEDIUM} level={3} marginTop={SPACE.SPACE_2}>
                {formatMessage(TEXT.SUBTITLE)}
              </Text>
              <InputField
                defaultValue={currentValue || ''}
                emptyOptionText={selectText}
                label={selectText}
                marginTop={SPACE.SPACE_6}
                onChange={redirectToLocationHref}
                options={countryList}
                value={currentValue}
                name="countrySelector"
                id="country-select"
                icon="arrow_down"
              />
            </Box>
            <Box>
              <MaskBottom />
            </Box>
          </Box>
        </Layout>
      </Aurora>
    </>
  );
};
